export enum ComponentNameConstants {
  DME = 'DME',
  Facility = 'Facility',
  Surgery = 'Surgery',
  PTLocation = 'PT Location',
  InitialEval = 'Initial Evaluation',
  TakeoverOfCare = 'Takeover of Care',
}
